import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CpanelLayout from '../../components/cpanel/CpanelLayout';
import CpanelDashboardPage from '../../pages/cpanel/dashboard';
import CpanelTenantsPage from '../../pages/cpanel/tenants';
import CpanelUsersPage from '../../pages/cpanel/users';
import CpanelLogsPage from '../../pages/cpanel/logs';
import CpanelJobPage from '../../pages/cpanel/jobs';
import CpanelNotificationsPage from '../../pages/cpanel/notifications';
import { CpanelAuthGuard } from './guards/cpanelAuth';

const CpanelRoutes = () => (
  <Routes>
    <Route element={<CpanelAuthGuard />}>
      <Route element={<CpanelLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<CpanelDashboardPage />} />
        <Route path="tenants" element={<CpanelTenantsPage />} />
        <Route path="users" element={<CpanelUsersPage />} />
        <Route path="logs" element={<CpanelLogsPage />} />
        <Route path="notifications" element={<Navigate to="notifications/all" replace />} />
        <Route path="notifications/:tab" element={<CpanelNotificationsPage />} />
        <Route path="jobs/:id" element={<CpanelJobPage />} />
      </Route>
    </Route>
  </Routes>
);

export default CpanelRoutes;
